import { EuiSpacer } from '@elastic/eui';
import AreasTable from 'components/Web_User_Interface/720p_Series/Alarm/Areas/areasTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  AreasTable,
  BreadCrumbs,
  SEOHelmet,
  React
};